<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        </div>
        <Loader :is-loading="loading">
          <div class="row mt-5">
            <div class="col-12 col-md-6 col-lg-3 mb-4" v-for="(status, index) in opportunitiesTotalByStatus" :key="index">
              <div class="card p-3 h-100 bg-light-primary" >
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :class="'bg-'+filterStatus(status.name)[0]?.className">
                      <span style="color: white;">{{ status.count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <a class="text-black fs-6 fw-bolder">
                        {{filterStatus(status.name)[0]?.[locale]}}
                      </a>
                      <span class="fw-bold d-block fs-7 mt-2" :class="'text-'+filterStatus(status.name)[0]?.className">{{formattedLocalAmount(status?.amount)}} {{defaultCurrency?.symbol}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {formattedLocalAmount} from "@/mixins/Helpers";
import { computed,  onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useLocales } from "@/composables/locales";
import Loader from "@/components/Loader.vue";

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function} ,
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const opportunitiesTotalByStatus = ref([])


const opportunityStatus = computed(() => store.getters['pipelines/pipelineStatusEnum'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
           opportunitiesTotalByStatus.value = res?.data?.opportunitiesTotalByStatus || res?.response?.data
        }),
        store.dispatch('pipelines/loadPipelineStatusEnum'),

    ]).then(() => {
    })
}

function filterStatus(value){
    let status = opportunityStatus.value.filter(status => status.value === value)
    return status
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})
</script>  